<template>
    <transition name="slide-fade">
        <div v-show="show" class="m-sticky-info">
            <h2 :style="hightStyle" class="u-title">{{ title }}</h2>
            <div class="u-infos">
                <span v-if="isTop" class="u-status u-sub-block top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect width="24" height="24" rx="4" fill="#FF6969"/><path d="M5.654 10.916l7.671 7.94s4.819-9.49 7.194-9.003c2.376.488-6.481-9.125-5.852-6.28.63 2.845-9.013 7.343-9.013 7.343z" fill="#FFF"/><path d="M4.114 9.325L14.852 20.44l-1.055-5.26-4.602-4.763-5.081-1.092zM3.09 20.808l7.06-5.225L8.137 13.5l-5.048 7.309z" fill="#FFF"/></svg>
                </span>

                <span v-if="isStar" class="u-status u-sub-block star">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15 7.5L9.515 5.485 7.5 0 5.485 5.485 0 7.5l5.485 2.015L7.5 15l2.015-5.485L15 7.5z" fill="#FFF"/></svg>
                </span>

                <span
                    v-for="(item, index) in tags"
                    :key="index"
                    class="u-tag u-meta u-sub-block"
                    :style="{ backgroundColor: item.color }"
                >
                    {{ item.label }}
                </span>

                <a v-if="collection" class="u-book u-sub-block u-meta" :href="collection.url" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16" fill="none" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" fill="#A6A6A6" d="M5.5 12.1L0 16V0h11v16l-5.5-3.9z"/></svg>
                    {{ collection.name }}
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ["post"],
    data() {
        return {
            show: false,
        };
    },
    computed: {
        hightStyle: function () {
            if (this.post.is_hight && this.post.hight_color) {
                return {
                    color: this.post.hight_color,
                };
            } else {
                return {};
            }
        },
        collection: function () {
            if (this.post.collection && this.post.collection.title) {
                return {
                    name: this.post.collection.title,
                    url: `/collection/${this.post.collection_id}`,
                };
            }
            return null;
        },
        tags: function () {
            return this.post?.color_tag;
        },
        isStar: function () {
            return this.post?.is_star;
        },
        isTop: function () {
            return this.post?.is_top || this.post?.is_category_top;
        },
        title: function () {
            return this.post?.title || "无标题";
        },
    },
    mounted() {
        document.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const dom = document.getElementsByClassName("m-single-header");
            if (dom.length) {
                const rect = dom[0].getBoundingClientRect();
                if (document.documentElement.scrollTop > rect.y + rect.height) {
                    this.show = true;
                } else {
                    this.show = false;
                }
            }
        },
    },
};
</script>

<style lang="less" scoped>
.m-sticky-info {
    display: flex;
    gap: 8px;
    // opacity: 0;
    // transition: 0.5s;
    // &.active {
    //     opacity: 1;
    // }
    .u-title {
        .bold;
        .fz(16px,28px);
        margin: 0;
        display: inline-block;
        color: #3d454d;

        white-space: nowrap; /* 保持文本在一行显示 */
        overflow: hidden;
        text-overflow: ellipsis; /* 超出部分用省略号表示 */
    }
    .u-infos {
        .flex;
        gap: 8px;
        align-items: center;

        .u-status {
            .flex;
            gap: 1px;
            align-items: center;
            color: white;
            height: 22px;
            width: 22px;
            border-radius: 4px;
            box-sizing: border-box;
            user-select: none;
            justify-content: center;
            &.top {
                background: rgba(255, 105, 105, 1);
            }
            &.star {
                background: rgba(255, 187, 105, 1);
            }
        }
        .u-tag {
            .fz(14px,22px);
            padding: 0 6px;
            border-radius: 4px;
            background: @color;
            color: #fff;
        }
        .u-podate {
            margin-left: 10px;
        }
        .u-book {
            .fz(12px,22px);
            position: relative;
            padding-left: 27px;
            padding-right: 8px;
            border-radius: 4px;
            border: 1px solid rgba(146, 148, 151, 1);
            color: rgba(146, 148, 151, 1);
            box-sizing: border-box;
            svg {
                position: absolute;
                left: 12px;
                top: 0;
                width: 11px;
                height: 16px;
                margin-right: 0;
            }
        }
    }
}
@media screen and (max-width: @ipad) {
    .u-meta {
        display: none;
    }
}
@media screen and (max-width: @phone) {
    .u-podate {
        display: none;
    }
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}
</style>
